// Timing constants
export const REASONING_INTERVAL_MS = 2000
export const TYPEWRITER_DELAY = 25
export const TYPEWRITER_SCROLL_INTERVAL = 500
export const SHIMMER_DURATION_S = 4

// Polling constants
export const UPDATES_LIMIT = 100
export const INITIAL_POLL_INTERVAL = 2000
export const SLOW_POLL_INTERVAL = 5000

// Colors
export const FACESIGN_GREEN = '#16C95D'
export const TYPEWRITER_CURSOR_COLOR = '#10b981'
export const SHIMMER_GRADIENT =
  'linear-gradient(90deg, #ffffff 0%, #dcfce7 50%, #ffffff 100%)'
